
import { useState, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const MEDIA_BASE_URL = "https://bumppy.in/anlook/api";
const Media_Base_Url = "https://api.anlook.com/api";

const useMedia = () => {
  const { userID, basicAuth } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(async (endpoint, body) => {
    const res = await fetch(`${MEDIA_BASE_URL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const text = await res.text();

    try {
      return JSON.parse(text);
    } catch {
      console.error("Invalid JSON response");
      return null;
    }
  }, []);

  /* ===============================
     IMAGE UPLOAD
  =============================== */

  const uploadImage = useCallback(
    async (imageName, base64String) => {
      try {
        setLoading(true);

        const data = await postRequest("/v1/uploadItemImage.php", {
          userid: userID,
          item_name: imageName,
          type: "IMG",
          image_data: base64String,
        });

        return data;
      } catch (err) {
        console.error("Upload Image Error:", err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [postRequest, userID]
  );

  /* ===============================
     VIDEO UPLOAD
  =============================== */

  const uploadVideo = useCallback(
    async (file) => {
      try {
        setLoading(true);

        const reader = new FileReader();

        return new Promise((resolve) => {
          reader.onload = async () => {
            const base64 = reader.result.split(",")[1];

            const payload = {
              userid: userID,
              mediaType: "video",
              mediaData: base64,
            };

            const res = await fetch(`${Media_Base_Url}/Whatsapp/uploadMedia`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: basicAuth,
              },
              body: JSON.stringify(payload),
            });

            const data = await res.json();
            resolve(data);
          };

          reader.readAsDataURL(file);
        });
      } catch (err) {
        console.error("Upload Video Error:", err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [userID, basicAuth]
  );

  /* ===============================
     DOCUMENT UPLOAD
  =============================== */

  const uploadDocument = useCallback(
    async (file) => {
      try {
        setLoading(true);

        const reader = new FileReader();

        return new Promise((resolve) => {
          reader.onload = async () => {
            const base64 = reader.result.split(",")[1];

            const payload = {
              userid: userID,
              mediaType: "pdf",
              mediaData: base64,
            };

            const res = await fetch(`${Media_Base_Url}/Whatsapp/uploadMedia`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: basicAuth,
              },
              body: JSON.stringify(payload),
            });

            const data = await res.json();
            resolve(data);
          };

          reader.readAsDataURL(file);
        });
      } catch (err) {
        console.error("Upload Document Error:", err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [userID, basicAuth]
  );

  /* ===============================
     CAMPAIGN EXCEL UPLOAD
  =============================== */

  const uploadCampaignExcel = useCallback(
    async (file) => {
      try {
        setLoading(true);

        const reader = new FileReader();

        return new Promise((resolve) => {
          reader.onload = async () => {
            const base64 = reader.result.split(",")[1];

            const payload = {
              userid: userID,
              file_name: file.name.split(".")[0],
              file_data: base64,
              type: "XLSX",
            };

            const res = await fetch(
              `${MEDIA_BASE_URL}/v1/uploadCampaignExcel.php`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
              }
            );

            const data = await res.json();
            resolve(data);
          };

          reader.readAsDataURL(file);
        });
      } catch (err) {
        console.error("Upload Excel Error:", err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [userID]
  );

  const uploadMediaImage = useCallback(
  async (imageName, base64String) => {
    try {
      setLoading(true);

      const res = await fetch(`${Media_Base_Url}/Whatsapp/uploadMedia`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: basicAuth,
        },
        body: JSON.stringify({
          userid: userID,
          mediaType: "img",
          mediaData: base64String,
        }),
      });

      const data = await res.json();
      return data;
    } catch (err) {
      console.error("Upload Image Error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  },
  [userID, basicAuth]
);

  return {
    uploadImage,
    uploadVideo,
    uploadDocument,
    uploadCampaignExcel,
    uploadMediaImage,
    loading,
  };
};

export default useMedia;